import { render, staticRenderFns } from "./RedirectSubscription.vue?vue&type=template&id=5aba2dfb&"
import script from "./RedirectSubscription.vue?vue&type=script&lang=js&"
export * from "./RedirectSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports